<template>
  <router-view />
</template>

<script>
export default {
  name: 'Gender'
}
</script>

<style scoped>

</style>
